import React from 'react';
import { FaArrowUp, FaHome, FaGamepad, FaTrophy } from 'react-icons/fa';

const Footer = ({ isLightMode }) => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Year for copyright notice
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[var(--footer-background-color)] text-[var(--text-color)] py-8 px-4 mt-auto">
      <div className="max-w-6xl mx-auto">
        {/* Main Footer Content */}
        <div className="flex flex-col md:flex-row justify-between items-center mb-8">
          {/* Logo and Copyright */}
          <div className="mb-6 md:mb-0 text-center md:text-left">
            <h2 className="text-3xl md:text-4xl font-bold mb-3 font-['Jersey_25',sans-serif]">
              Quiz Arcade
            </h2>
            <p className="opacity-80 text-sm">
              © {currentYear} Quiz Arcade. All rights reserved.
            </p>
          </div>
          
          {/* Navigation Links */}
          <nav className="mb-6 md:mb-0">
            <ul className="flex flex-wrap justify-center gap-2 md:gap-8">
              <li>
                <button 
                  onClick={scrollToTop} 
                  className="flex items-center px-4 py-2 rounded-lg transition-colors duration-300 hover:bg-[var(--interactive-color)] hover:text-white focus:outline-none focus:ring-2 focus:ring-[var(--focus-outline-color)]"
                  aria-label="Scroll to top of page"
                >
                  <FaArrowUp className="mr-2" /> Back to Top
                </button>
              </li>
              <li>
                <a 
                  href="/" 
                  className="flex items-center px-4 py-2 rounded-lg transition-colors duration-300 hover:bg-[var(--interactive-color)] hover:text-white focus:outline-none focus:ring-2 focus:ring-[var(--focus-outline-color)]"
                >
                  <FaHome className="mr-2" /> Home
                </a>
              </li>
              <li>
                <a 
                  href="/games" 
                  className="flex items-center px-4 py-2 rounded-lg transition-colors duration-300 hover:bg-[var(--interactive-color)] hover:text-white focus:outline-none focus:ring-2 focus:ring-[var(--focus-outline-color)]"
                >
                  <FaGamepad className="mr-2" /> Dashboard
                </a>
              </li>
              <li>
                <a 
                  href="/leaderboards" 
                  className="flex items-center px-4 py-2 rounded-lg transition-colors duration-300 hover:bg-[var(--interactive-color)] hover:text-white focus:outline-none focus:ring-2 focus:ring-[var(--focus-outline-color)]"
                >
                  <FaTrophy className="mr-2" /> Leaderboard
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </footer>
  );
};

export default Footer;